export const MAX_TARIFF_LINES_SHOW = 8;
